import getIsRTLLanguage from 'utils/common/isRTL';

const theme = {
  colors: {
    buttonPrimary: '#e60000',
    buttonSecondary: '#ffffff',
    containerBackground: 'rgba(0, 0, 0, 0.3)',
    containerBackgroundSecondary: 'rgba(255, 255, 255, 0.8)',
    textPrimary: '#ffffff',
    textActive: '#ffffff',
    textInactive: '#000000',
    iconInactive: '#e60000',
    iconActive: '#ffffff',
    background: '#ffffff',
    // New properties to support blue/styles.js
    glassBackground: 'rgba(255, 255, 255, 0.1)',
    glassOverlay: 'rgba(255, 255, 255, 0.2)',
    sidebarBackground: 'rgba(39, 50, 71, 0.8)',
  },
  fonts: {
    main: `${getIsRTLLanguage() ? 'Helvetica' : 'Din'}, sans-serif`,
  },
  effects: {
    // Optimized Transitions for TV
    transitionFast: 'all 0.15s ease-out',
    transitionMedium: 'all 0.25s ease-out',
    transitionSlow: 'all 0.35s ease-out',

    // Simplified Backdrop Filters for TV
    backdropBlur: 'blur(8px)', // Reduced from 20px
    backdropBlurLight: 'blur(4px)', // Reduced from 10px
    backdropBlurHeavy: 'blur(12px)', // Reduced from 30px

    // Border Radius
    borderRadiusSmall: '8px',
    borderRadiusMedium: '12px', // Reduced from 16px
    borderRadiusLarge: '16px', // Reduced from 24px
    borderRadiusXLarge: '20px', // Reduced from 32px
  },
};

const themeCharcoalBlue = {
  // TV-Optimized Theme - Charcoal Blue Colors
  colors: {
    // Core Colors - Different from main theme but same structure
    buttonPrimary: '#273247', // Charcoal blue
    buttonSecondary: '#ffffff',
    containerBackground: 'rgba(255, 255, 255, 0.8)',
    containerBackgroundSecondary: 'rgba(255, 255, 255, 0.8)',
    textPrimary: '#ffffff',
    textActive: '#ffffff',
    textInactive: '#000000',
    iconInactive: '#ffffff',
    iconActive: '#ffffff',
    background: '#ffffff',
    // New properties to support blue/styles.js
    glassBackground: 'rgba(39, 50, 71, 0.3)',
    glassOverlay: 'rgba(255, 255, 255, 0.2)',
    sidebarBackground: 'rgba(39, 50, 71, 0.8)',
  },
  fonts: {
    main: `${getIsRTLLanguage() ? 'Helvetica' : 'Din'}, sans-serif`,
  },
  effects: {
    // Optimized Transitions for TV
    transitionFast: 'all 0.15s ease-out',
    transitionMedium: 'all 0.25s ease-out',
    transitionSlow: 'all 0.35s ease-out',

    // Simplified Backdrop Filters for TV
    backdropBlur: 'blur(8px)', // Reduced from 20px
    backdropBlurLight: 'blur(4px)', // Reduced from 10px
    backdropBlurHeavy: 'blur(12px)', // Reduced from 30px

    // Border Radius
    borderRadiusSmall: '8px',
    borderRadiusMedium: '12px', // Reduced from 16px
    borderRadiusLarge: '16px', // Reduced from 24px
    borderRadiusXLarge: '20px', // Reduced from 32px
  },
};

const themeMaroonish = {
  // TV-Optimized Theme - Maroon Colors
  colors: {
    // Core Colors - Different from main theme but same structure
    buttonPrimary: '#70383b', // Maroon
    buttonSecondary: '#ffffff',
    containerBackground: 'rgba(255, 255, 255, 0.8)',
    containerBackgroundSecondary: 'rgba(255, 255, 255, 0.8)',
    textPrimary: '#ffffff',
    textActive: '#ffffff',
    textInactive: '#000000',
    iconInactive: '#ffffff',
    iconActive: '#ffffff',
    background: '#ffffff',
    // New properties to support blue/styles.js
    glassBackground: 'rgba(112, 56, 59, 0.5)',
    glassOverlay: 'rgba(255, 255, 255, 0.2)',
    sidebarBackground: 'rgba(112, 56, 59, 0.8)',
  },
  fonts: {
    main: `${getIsRTLLanguage() ? 'Helvetica' : 'Din'}, sans-serif`,
  },
  effects: {
    // Optimized Transitions for TV
    transitionFast: 'all 0.15s ease-out',
    transitionMedium: 'all 0.25s ease-out',
    transitionSlow: 'all 0.35s ease-out',

    // Simplified Backdrop Filters for TV
    backdropBlur: 'blur(8px)', // Reduced from 20px
    backdropBlurLight: 'blur(4px)', // Reduced from 10px
    backdropBlurHeavy: 'blur(12px)', // Reduced from 30px

    // Border Radius
    borderRadiusSmall: '8px',
    borderRadiusMedium: '12px', // Reduced from 16px
    borderRadiusLarge: '16px', // Reduced from 24px
    borderRadiusXLarge: '20px', // Reduced from 32px
  },
};

export { themeCharcoalBlue, themeMaroonish };
